import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Title from './title';
import PhotoNews from './photoNews';
/**
 * 定义 Content 组件
 */
class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        page: 1,
        totalPage: this.props.content.slideData ? this.props.content.slideData.length : 0,
    };

    changePageCallback = current => {
        this.setState({ page: current });
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { titleData, slideData, nextSlide },
        } = this.props;
        const { page, totalPage } = this.state;
        const pageData = { page, totalPage };

        return (
            <div className={styles.container}>
                <Title content={titleData} pageData={pageData} />
                {/* title */}
                <PhotoNews content={slideData} nextSlide={nextSlide} changePageCallback={this.changePageCallback} />
                {/* slide */}
            </div>
        );
    }
}

export default errorBoundary(Content);
